import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonCodeBlock
  from 'components/atoms/Editors/EditorMenuButtonCodeBlock/EditorMenuButtonCodeBlock.styles';

const EditorMenuButtonCodeBlock = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonCodeBlock');

  return <StyledEditorMenuButtonCodeBlock buttonRef={ref} {...innerProps} />
});

EditorMenuButtonCodeBlock.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonCodeBlock;
